/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

export function downloadFile(response: any): void {
  const downloadLink = document.createElement('a');
  const contentDisposition = response.headers.get('content-disposition');
  const fileName = contentDisposition.replace('attachment; filename=', '');
  downloadLink.href = window.URL?.createObjectURL(new Blob([response.body]));
  downloadLink.setAttribute('download', fileName);
  document.body.appendChild(downloadLink);
  downloadLink.click();
}
